export default "__VITE_ASSET__e0ed7ac2__"